module.exports = __webpack_public_path__ + "img/Worthington_Bill_CN13849159_20191114.a8696a59.jpeg";